import { render, staticRenderFns } from "./CaseFileUpload.vue?vue&type=template&id=f214f37a&scoped=true"
import script from "./CaseFileUpload.vue?vue&type=script&lang=js"
export * from "./CaseFileUpload.vue?vue&type=script&lang=js"
import style0 from "./CaseFileUpload.vue?vue&type=style&index=0&id=f214f37a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f214f37a",
  null
  
)

export default component.exports